import { ComposeViewState } from 'owa-mail-compose-store';
import { action } from 'satcheljs/lib/legacy';

export default action('clearAttachmentFilesToUpload')(function clearAttachmentFilesToUpload(
    viewState: ComposeViewState
) {
    viewState.attachmentFilesToUpload = null;
});
